export default {
  // 驗證碼用途
  FEATURE_SITE_ADMIN_RESET_PASSWORD: 'site-admin-reset-password', // 管理員-重設密碼
}
